import { PATHS } from "@/lib/router";
import { DashboardPage, ComponentsShowcase } from "./pages";

const isLocalhost =
  typeof window !== "undefined" && window.location.hostname === "localhost";

export const dashboardRoutes = [
  {
    path: PATHS.DASHBOARD,
    element: <DashboardPage />,
  },
  ...(isLocalhost
    ? [
        {
          path: PATHS.COMPONENTS,
          element: <ComponentsShowcase />,
        },
      ]
    : []),
];
